export default {
  // TITLE
  TitleControl: '',
  ShowTitleControl: { checked: true },
  StyleTitleControl: {
    fontSize: 20,
    color: '#000000',
    fontFamily: 'arial',
    bold: false,
    italic: false,
    underline: false,
    align: 'center',
  },
  // GENERAL
  SortValuesControl: 'Valor Decrescente',
  CustomSortControl: {
    checked: false, kpiCategories: [],
  },
  ReverseControl: { checked: false },
  LayoutControl: 'vertical',
  ValueScaleControl: 'linear',
  PaddingControl: { value: 0 },
  Margin: {
    top: 50,
    right: 165,
    bottom: 55,
    left: 95,
  },
  MinValueControl: { value: 0, checked: true, pai: true },
  MaxValueControl: { value: 0, checked: true, pai: true },
  ExtendDateLine: false,
  DataFormat: 'absolute', // { type: 'absolute', target: 'global' },
  DataPercentFormat: 'global',
  DataAbsoluteFormat: 'number',
  DurationUnit: 'hours',
  // STYLE
  BorderRadiusControl: { value: 0 },
  BorderWidthControl: { value: 0 },
  BorderColorControl: { from: 'color', modifiers: [['darker', 1.6]] },
  PalletsControl: 'default',
  ColorTheme: { scheme: 'nivo' },
  GradientPickerControl: {
    color1: '#4711B2',
    color2: '#FF9626',
    color3: null,
  },
  LineWidthControl: 2,
  LineColorControl: '#F1220F',
  LineFormatControl: 'linear',
  EnablePointsControl: true,
  PointsSizeControl: 10,
  PointsColorControl: '#8E0C00',
  PointsBorderWidthControl: 2,
  Colors: {},
  UseGlobalColor: true,
  UseGlobalFont: true,
  // LABEL
  EnableLabelControl: { checked: true },
  LabelFormatControl: 'Central',
  LabelTextColorControl: {
    from: 'color',
    modifiers: [['darker', 1.6]],
  },
  LabelRotationControl: 0,
  LabelTranslateX: 0,
  LabelTranslateY: 0,
  EnableLabelMinControl: false,
  LabelMinPercentControl: 0,
  EnableLabelPointsControl: true,
  LabelTextColorPointsControl: '#333333',
  LabelRotationPointsControl: 0,
  LabelTranslateXPoints: 0,
  LabelTranslateYPoints: 0,
  LabelsFontFamilyControl: { value: 'sans-serif' },
  LabelsFontSizeControl: { value: 12 },
  PrefixControl: '',
  SufixControl: '',
  Decimals: 'auto',
  separadorNumericoCasas: '0',
  LabelCurrencyControl: 'Nenhum',
  LabelGroupingControl: '',
  // AXIS
  EnableGridX: false,
  EnableGridY: true,
  EnableAxisX: {
    axisTop: false,
    axisBot: true,
    maxLabelLines: 1,
    tickSize: 5,
    tickPadding: 12,
    tickRotation: 0,
    legend: '',
    legendOffset: 35,
    Decimals: 'auto',
    separadorNumericoCasasX: 0,
  },
  EnableAxisY: {
    axisLeft: true,
    axisRight: true,
    tickSize: 5,
    tickPadding: 5,
    tickRotation: 0,
    legend: '',
    legendOffset: -55,
    Decimals: 'auto',
    separadorNumericoCasasY: 0,
  },
  DecimalsYPercent: 0,
  CurrencyControl: 'Nenhum',
  GroupingSelectControl: '',
  AxisGlobal: {
    fontFamily: 'arial',
    fontSize: 12,
    legendFontSize: 12,
    color: '#333333',
  },
  // LEGEND
  LegendControl: { checked: true },
  ColorByControl: 'auto',
  LegendPlacementControl: {
    value: {
      label: 'Direita',
      translateX: 145,
      translateY: 0,
      selectedPosition: 'right',
      direction: 'column',
      anchor: 'right',
    },
  },
  LegendsFontFamilyControl: { value: 'sans-serif' },
  LegendsFontSizeControl: { value: 12 },
  LegendBold: false,
  LegendItalic: false,
  LegendFontColor: '#999',
  LegendMaxLines: 1,
  LegendsSpacingControl: { value: 10 },
  LegendSymbolControl: 'circle',
  // TOOLTIP / INTERACTIVE
  InteractiveControl: true,
  InteractivePrefixControl: '',
  InteractiveSufixControl: '',
  InteractiveDecimals: 'auto',
  InteractiveSeparadorNumericoCasas: 0,
  InteractiveSeparadorNumericoCasasPercentuais: 0,
  InteractiveCurrencyControl: 'Nenhum',
  InteractiveGroupingControl: 'Nenhum',
  Animate: false,
  MotionConfig: 'default',
};
